export default () => {
  window.addEventListener('error', e => {
    console.error('[error]', e.message, e.filename, e.lineno, e.colno, e.error && e.error.stack);
  });
  window.addEventListener('unhandledrejection', e => {
    const r = e.reason || {};
    console.error('[unhandledrejection]', r.message || r, r.stack);
  });
};
